import React from 'react'

import AnnouncementsForm from '../form/AnnouncementsForm'
import { Paper, makeStyles } from '@material-ui/core'
import AnnouncementView from './AnnouncementView'
import SearchAnnouncementsForm from '../form/SearchAnnouncementsForm'

const useStyles = makeStyles(theme => ({
  header: {
    marginLeft: '1.3vw',
    '& h1': {
      color: '#4D5E80',
      marginBottom: 0,
      fontSize: 32,
      [theme.breakpoints.down('426')]: {
        fontSize: 22
      }
    },
    '& p': {
      margin: '0px 0px 25px 0px',
      fontSize: 16,
      [theme.breakpoints.down('426')]: {
        fontSize: 14
      }
    }
  }
}))

const AnnouncementsView = ({
  title,
  eventType,
  isAdmin,
  match,
  componentAttribute
}) => {
  const eventId = match.params?.eventId
  const classes = useStyles()
  if (componentAttribute?.isCreate) {
    return (
      <Paper style={{ borderRadius: 8, padding: 32 }} elevation={0}>
        <div>
          <AnnouncementsForm eventType={eventType} />
        </div>
      </Paper>
    )
  } else if (componentAttribute?.isEdit) {
    return (
      <Paper style={{ borderRadius: 8, padding: 32 }} elevation={0}>
        <div>
          <AnnouncementsForm eventType={eventType} isEdit eventId={eventId} />
        </div>
      </Paper>
    )
  } else if (componentAttribute?.isView) {
    return (
      <div>
        <div className={classes.header}>
          <h1>Detalhes do comunicado</h1>
          <p> Visualize todos os detalhes do comunicado enviado</p>
        </div>
        <AnnouncementView eventType={eventType} eventId={eventId} />
      </div>
    )
  } else if (componentAttribute?.isReview && isAdmin) {
    return (
      <Paper style={{ borderRadius: 8, padding: 32 }} elevation={0}>
        <div>
          <AnnouncementsForm
            eventType={eventType}
            isEdit
            eventId={eventId}
            isReview
          />
        </div>
      </Paper>
    )
  }
  return (
    <Paper style={{ borderRadius: 8, padding: 32 }} elevation={0}>
      <div>
        <SearchAnnouncementsForm eventType={eventType} />
      </div>
    </Paper>
  )
}

export default AnnouncementsView
